import common from './common'
import check from './check'
import organize from './organize'
import permission from './permission'
import dimission from './dimission'
import shift from './shift'
import staff from './staff'
import talents from './talents'
import workTable from './workTable'
import otherTable from './otherTable'
import reimburse from './reimburse'
import setMenus from './setMenus'
import advertManage from './advertManage'
import express from './express'
import leaveSituation from './leaveSituation'
import notice from './notice'

let Apis = {
    common,
    check,
    organize,
    permission,
    dimission,
    shift,
    staff,
    talents,
    workTable,
    otherTable,
    reimburse,
    setMenus,
    advertManage,
    express,
    leaveSituation,
    notice
}

export default Apis;


// WEBPACK FOOTER //
// ./src/api/config/index.js